export const mapMonthAbrevToFull = (input: string): string => {
  const abrev = input.toLowerCase();
  switch (abrev) {
    case 'jan': return 'Janeiro';
    case 'fev': return 'Fevereiro';
    case 'mar': return 'Março';
    case 'abr': return 'Abril';
    case 'mai': return 'Maio';
    case 'jun': return 'Junho';
    case 'jul': return 'Julho';
    case 'ago': return 'Agosto';
    case 'set': return 'Setembro';
    case 'out': return 'Outubro';
    case 'nov': return 'Novembro';
    case 'dez': return 'Dezembro';
    default: return input;
  }
};

export const mapMonthNumberToFull = (input: string): string => {
  const abrev = parseInt(input.toLowerCase());
  switch (abrev) {
    case 1: return 'Janeiro';
    case 2: return 'Fevereiro';
    case 3: return 'Março';
    case 4: return 'Abril';
    case 5: return 'Maio';
    case 6: return 'Junho';
    case 7: return 'Julho';
    case 8: return 'Agosto';
    case 9: return 'Setembro';
    case 10: return 'Outubro';
    case 11: return 'Novembro';
    case 12: return 'Dezembro';
    default: return input;
  }
};

export const dateToText = (date: string) => {
  let [dia, mes, ano] = date.split('/');
  dia = parseInt(dia, 10).toString();
  dia = dia === "1" ? "primeiro" : dia;
  return `${dia} de ${mapMonthNumberToFull(mes)} de ${ano}`;
}
